<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <input
      type="checkbox"
      :id="id"
      :checked="modelValue"
      :disabled="disabled"
      class="custom-check"
      :aria-describedby="`${id}-help`"
      :class="{ 'p-invalid': validation?.$error }"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <label :for="id" class="ml-2">{{ label }}</label>
    <span
      v-if="validation?.$error && validation?.required?.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2 block"
    >
      {{ PropName }} is required.
    </span>
    <span
      v-else-if="
        validation?.$error &&
        validation?.requiredIf &&
        validation?.requiredIf.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2 block"
    >
      {{ validation.requiredIf.$message.replace("value", PropName) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    sectionClass: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    PropName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-check {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #c0c0bc;
  border-radius: 4px;
  background: #fff;
  transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  position: relative;
  cursor: pointer;
  // padding: 10px;
}

.custom-check:checked {
  background-color: #43a584;
  border: 1px solid #348067;
}

.custom-check:checked::after {
    content: "";
    position: absolute;
    top: 1px;
    left: 5px;
    width: 4px;
    height: 10px;
    border: solid #fff;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);

//   transition-duration: 0.15s; // same as .p-checkbox-icon
//   color: #fff; // tick color
//   font-size: 10px; // mimic icon sizing
//   background-color: #43a584;
}

.custom-check:hover:not(:disabled) {
  border-color: #2d6e6d;
}

.custom-check:focus {
  outline: none;
  border: 1px solid #348067;
  box-shadow: none;
}

.custom-check.p-invalid {
  border-color: #dc3545;
}

.custom-check:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}
</style>
